import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import store from '@/store';
import 'vuetify/dist/vuetify.min.css'
import '@aws-amplify/ui-vue';
import 'vuex-toast/dist/vuex-toast.css'
import '@/api/amplify-confg';
var log = require('log-util');

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.config.productionTip = false;

async function f() {
  return new Promise((resolve) => {
    setTimeout(() => resolve('done!'), 3000);
  });
}

new Vue({
  store,
  router,
  vuetify,
  async beforeCreate() {
    if (store.state.userRole) {
      this.$mount('#app');
    } else {
      await f();
      try {
        await store.dispatch('setUser');
        this.$mount('#app');
      } catch (error) {
        log.error("login error", error)
      }
    }
  },
  render: h => h(App)
});
